<template>
  <main class="index">
    <section class="main-hero">
      <div class="section-wrap">
        <a class="hero-banner" href="https://codepresso.io/home/news" target="_blank" rel="noopener">
          <span class="tag">LATEST</span>
          <span class="hero-banner-text" data-i18n="index-hero-banner" v-html="$rt('index-hero-banner')"></span>
          <svg class="hero-banner-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </a>

        <div class="hero-content">
          <div class="main-hero-copy">
            <h1 data-i18n="index-hero-title" v-html="$rt('index-hero-title')"></h1>
            <p class="hero-description" data-i18n="index-hero-desc" v-html="$rt('index-hero-desc')"></p>

            <div class="hero-cta">
              <a class="btn btn-primary " href="https://codepresso.io/home/contact"><span data-i18n="index-hero-cta-primary" v-html="$rt('index-hero-cta-primary')"></span></a>
            </div>

            <div class="hero-links">
              <a class="link-arrow link-arrow-ink" href="/skills">
                <span class="link-underline" data-i18n="index-hero-link-01" v-html="$rt('index-hero-link-01')"></span>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </a>
              <a class="link-arrow link-arrow-ink" href="/axpresso">
                <span class="link-underline" data-i18n="index-hero-link-02" v-html="$rt('index-hero-link-02')"></span>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </a>
            </div>
          </div>

          <aside class="assessment-card-frame" aria-label="AI 리터러시 자가진단">
            <span class="assessment-card-frame__glow" aria-hidden="true"></span>
            <div class="assessment-card-stack">
              <span class="assessment-card-eyebrow">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"></circle><path d="M3 12h18M12 3c2.5 2.5 3.8 5.8 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.8-3.8-9S9.5 5.5 12 3Z" stroke="currentColor" stroke-width="1.6"></path></svg>
                <span data-i18n="index-hero-assessment-eyebrow" v-html="$rt('index-hero-assessment-eyebrow')"></span>
              </span>

              <article class="assessment-card">
                <div class="assessment-card__head">
                  <h3 data-i18n="index-hero-assessment-title" v-html="$rt('index-hero-assessment-title')"></h3>
                  <p class="description" data-i18n="index-hero-assessment-desc" v-html="$rt('index-hero-assessment-desc')"></p>
                </div>

                <ul class="assessment-card__meta" aria-label="진단 정보">
                  <li class="pill"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 4h7l4 4v12H7zM10 12h5M10 16h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg><span data-i18n="index-hero-assessment-meta-01" v-html="$rt('index-hero-assessment-meta-01')"></span></li>
                  <li class="pill"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6"></circle><path d="M12 8v4l3 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg><span data-i18n="index-hero-assessment-meta-02" v-html="$rt('index-hero-assessment-meta-02')"></span></li>
                  <li class="pill"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg><span data-i18n="index-hero-assessment-meta-03" v-html="$rt('index-hero-assessment-meta-03')"></span></li>
                </ul>

                <div class="assessment-card__action">
                  <a class="btn btn-primary  assessment-card__cta" href="https://ai-literacy.codepresso.io/"><span data-i18n="index-hero-assessment-cta" v-html="$rt('index-hero-assessment-cta')"></span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
                  <span class="assessment-card__hint"><span class="assessment-card__hint-tail" aria-hidden="true"></span><span class="assessment-card__hint-text" data-i18n="index-hero-assessment-hint" v-html="$rt('index-hero-assessment-hint')"></span></span>
                </div>
              </article>
            </div>
          </aside>

        </div>
      </div>

      <div class="hero-clients">
        <h3 class="hero-clients-title" data-i18n="index-hero-clients-title" v-html="$rt('index-hero-clients-title')"></h3>
        <ClientLogoMarquee />
      </div>
    </section>

    <section class="features fade-up">
      <div class="section-wrap col">
        <div class="section-header">
          <div class="section-title text-left">
            <p class="mini-title" data-i18n="index-features-eyebrow" v-html="$rt('index-features-eyebrow')"></p>
            <h2 data-i18n="index-features-title" v-html="$rt('index-features-title')"></h2>
            <p class="desc" data-i18n="index-features-desc" v-html="$rt('index-features-desc')"></p>
          </div>
          <div class="section-cta">
            <a href="/skills" class="btn btn-ghost"><span data-i18n="index-features-cta" v-html="$rt('index-features-cta')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </div>
        </div>
        <div class="section-content">
          <ol class="cycle">
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 17.21C14.2059 17.21 17.2101 14.2059 17.2101 10.5C17.2101 6.79422 14.2059 3.79004 10.5 3.79004C6.7942 3.79004 3.79004 6.79422 3.79004 10.5C3.79004 14.2059 6.7942 17.21 10.5 17.21Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path d="M10.5 4.5C12.0913 4.5 13.6174 5.13214 14.7426 6.25735C15.8678 7.38257 16.5 8.9087 16.5 10.5C16.5 12.0913 15.8678 13.6174 14.7426 14.7426C13.6174 15.8679 12.0913 16.5 10.5 16.5C8.9087 16.5 7.38257 15.8679 6.25735 14.7426C5.13214 13.6174 4.5 12.0913 4.5 10.5C4.5 8.9087 5.13214 7.38257 6.25735 6.25735C7.38257 5.13214 8.9087 4.5 10.5 4.5ZM10.5 2C8.24647 2.00265 6.08599 2.89904 4.49251 4.49252C2.89902 6.08601 2.00265 8.24647 2 10.5C2 11.6162 2.21985 12.7215 2.64702 13.7528C3.07418 14.7841 3.7003 15.7211 4.48959 16.5104C5.27889 17.2997 6.21592 17.9258 7.24719 18.353C8.27846 18.7801 9.38376 19 10.5 19C11.6166 19.0013 12.7225 18.7824 13.7544 18.3557C14.7862 17.929 15.7238 17.3029 16.5133 16.5133C17.3029 15.7238 17.929 14.7862 18.3557 13.7544C18.7824 12.7225 19.0013 11.6166 19 10.5C19 8.24566 18.1045 6.08365 16.5104 4.48959C14.9163 2.89553 12.7543 2 10.5 2Z" fill="currentColor"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4852 14.7068L21.8852 20.1168L20.1158 21.8829L14.7158 16.4729L16.4852 14.7068Z" fill="currentColor"></path>
                </svg>
              </span>
              <div class="cycle-head">
                <p class="cycle-en" data-i18n="index-features-cycle-en-01" v-html="$rt('index-features-cycle-en-01')"></p>
              </div>
              <h3 data-i18n="index-features-cycle-title-01" v-html="$rt('index-features-cycle-title-01')"></h3>
              <p class="description" data-i18n="index-features-cycle-desc-01" v-html="$rt('index-features-cycle-desc-01')"></p>

              <div class="step-products-group">
                <p class="step-products-label" data-i18n="index-features-cycle-label-01" v-html="$rt('index-features-cycle-label-01')"></p>
                <ul class="step-products">
                  <li class="tag sm">AI Fluent</li>
                  <li class="tag sm">SkillCertify</li>
                </ul>
              </div>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path d="M10.49 8H6.5C6.22386 8 6 8.22386 6 8.5V9.5C6 9.77614 6.22386 10 6.5 10H10.49C10.7661 10 10.99 9.77614 10.99 9.5V8.5C10.99 8.22386 10.7661 8 10.49 8Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 8.58579L17.293 6.29289L18.7072 7.70711L15.0001 11.4142L12.293 8.70711L13.7072 7.29289L15.0001 8.58579Z" fill="currentColor"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 14.5858L17.293 12.2929L18.7072 13.7071L15.0001 17.4142L12.293 14.7071L13.7072 13.2929L15.0001 14.5858Z" fill="currentColor"></path>
                  <path d="M10.4998 14H6.50977C6.23362 14 6.00977 14.2239 6.00977 14.5V15.53C6.00977 15.8061 6.23362 16.03 6.50977 16.03H10.4998C10.7759 16.03 10.9998 15.8061 10.9998 15.53V14.5C10.9998 14.2239 10.7759 14 10.4998 14Z" fill="currentColor" fill-opacity="0.35"></path>
                </svg>
              </span>
              <div class="cycle-head">
                <p class="cycle-en" data-i18n="index-features-cycle-en-02" v-html="$rt('index-features-cycle-en-02')"></p>
              </div>
              <h3 data-i18n="index-features-cycle-title-02" v-html="$rt('index-features-cycle-title-02')"></h3>
              <p class="description" data-i18n="index-features-cycle-desc-02" v-html="$rt('index-features-cycle-desc-02')"></p>

              <div class="step-products-group">
                <p class="step-products-label" data-i18n="index-features-cycle-label-02" v-html="$rt('index-features-cycle-label-02')"></p>
                <ul class="step-products">
                  <li class="tag sm">SkillPath</li>
                  <li class="tag sm">SkillCamp</li>
                  <li class="tag sm">SkillFit</li>
                </ul>
              </div>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="is-return">
              <span class="cycle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 15H3C2.44772 15 2 15.4477 2 16V20C2 20.5523 2.44772 21 3 21H6C6.55228 21 7 20.5523 7 20V16C7 15.4477 6.55228 15 6 15Z" fill="currentColor"></path>
                  <path d="M13 9H10C9.44772 9 9 9.44772 9 10V20C9 20.5523 9.44772 21 10 21H13C13.5523 21 14 20.5523 14 20V10C14 9.44772 13.5523 9 13 9Z" fill="currentColor"></path>
                  <path d="M20 3H17C16.4477 3 16 3.44772 16 4V20C16 20.5523 16.4477 21 17 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z" fill="currentColor"></path>
                </svg>
              </span>
              <div class="cycle-head">
                <p class="cycle-en" data-i18n="index-features-cycle-en-03" v-html="$rt('index-features-cycle-en-03')"></p>
              </div>
              <h3 data-i18n="index-features-cycle-title-03" v-html="$rt('index-features-cycle-title-03')"></h3>
              <p class="description" data-i18n="index-features-cycle-desc-03" v-html="$rt('index-features-cycle-desc-03')"></p>

              <div class="step-products-group">
                <p class="step-products-label" data-i18n="index-features-cycle-label-03" v-html="$rt('index-features-cycle-label-03')"></p>
                <ul class="step-products">
                  <li class="tag sm">공유 허브</li>
                  <li class="tag sm">라이브러리</li>
                </ul>
              </div>
            </li>
          </ol>

          <p class="summary-banner dark" data-i18n="index-features-banner" v-html="$rt('index-features-banner')"></p>
        </div>
      </div>
    </section>

    <div class="dot-line"></div>

    <section class="outcomes fade-up">
      <div class="section-wrap col">
        <div class="section-header">
          <div class="section-title text-left">
            <p class="mini-title" data-i18n="index-outcomes-eyebrow" v-html="$rt('index-outcomes-eyebrow')"></p>
            <h2 data-i18n="index-outcomes-title" v-html="$rt('index-outcomes-title')"></h2>
            <p class="desc" data-i18n="index-outcomes-desc" v-html="$rt('index-outcomes-desc')"></p>
          </div>
          <div class="section-cta">
            <a href="/cases" class="btn btn-ghost"><span data-i18n="index-outcomes-cta-01" v-html="$rt('index-outcomes-cta-01')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
            <a href="https://codepresso.io/home/contact" class="btn btn-primary"><span data-i18n="index-outcomes-cta-02" v-html="$rt('index-outcomes-cta-02')"></span></a>
          </div>
        </div>
        <div class="section-content">
          <div class="summary-banner stats-light">
            <div class="summary-banner-stats" data-stat-reveal="">
              <article class="metric-card">
                <div class="metric-card__value">
                  <span class="num" data-target="39355">0</span><span class="unit">명</span>
                </div>
                <p class="metric-card__label text-label" data-i18n="index-outcomes-metric-label-01" v-html="$rt('index-outcomes-metric-label-01')"></p>
                <div class="metric-card__visual" aria-hidden="true">
                  <svg class="metric-card__icon" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9C7.06087 9 8.07827 9.42142 8.82841 10.1716C9.57856 10.9217 10 11.9391 10 13V18C10 18.2652 9.89464 18.5196 9.70711 18.7071C9.51957 18.8946 9.26522 19 9 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V13C2 11.9391 2.42142 10.9217 3.17157 10.1716C3.92172 9.42142 4.93913 9 6 9Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M6 8C7.38071 8 8.5 6.88071 8.5 5.5C8.5 4.11929 7.38071 3 6 3C4.61929 3 3.5 4.11929 3.5 5.5C3.5 6.88071 4.61929 8 6 8Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M21 19H15C14.7348 19 14.4804 18.8946 14.2929 18.7071C14.1053 18.5196 14 18.2652 14 18V13C14 11.9391 14.4214 10.9217 15.1716 10.1716C15.9217 9.42142 16.9391 9 18 9C19.0609 9 20.0783 9.42142 20.8284 10.1716C21.5786 10.9217 22 11.9391 22 13V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M18 8C19.3807 8 20.5 6.88071 20.5 5.5C20.5 4.11929 19.3807 3 18 3C16.6193 3 15.5 4.11929 15.5 5.5C15.5 6.88071 16.6193 8 18 8Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M11.1201 12H12.8701C13.931 12 14.9484 12.4214 15.6985 13.1716C16.4487 13.9217 16.8701 14.9391 16.8701 16V21C16.8701 21.2652 16.7648 21.5196 16.5772 21.7071C16.3897 21.8946 16.1353 22 15.8701 22H8.12012C7.8549 22 7.60055 21.8946 7.41301 21.7071C7.22547 21.5196 7.12012 21.2652 7.12012 21V16C7.12012 14.9391 7.54154 13.9217 8.29169 13.1716C9.04183 12.4214 10.0593 12 11.1201 12Z" fill="var(--color-brand)"></path>
                    <path d="M12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11Z" fill="var(--color-brand)"></path>
                  </svg>
                </div>
              </article>
              <article class="metric-card">
                <div class="metric-card__value">
                  <span class="num" data-target="1531">0</span><span class="unit">회</span>
                </div>
                <p class="metric-card__label text-label" data-i18n="index-outcomes-metric-label-02" v-html="$rt('index-outcomes-metric-label-02')"></p>
                <div class="metric-card__visual" aria-hidden="true">
                  <svg class="metric-card__icon" viewBox="0 0 24 24" fill="none">
                    <path d="M19.5 4.01953H4.5C3.39543 4.01953 2.5 4.91496 2.5 6.01953V19.0195C2.5 20.1241 3.39543 21.0195 4.5 21.0195H19.5C20.6046 21.0195 21.5 20.1241 21.5 19.0195V6.01953C21.5 4.91496 20.6046 4.01953 19.5 4.01953Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M8.48001 3.01953H7.5C7.22386 3.01953 7 3.24339 7 3.51953V5.51953C7 5.79567 7.22386 6.01953 7.5 6.01953H8.48001C8.75615 6.01953 8.98001 5.79567 8.98001 5.51953V3.51953C8.98001 3.24339 8.75615 3.01953 8.48001 3.01953Z" fill="var(--color-brand)"></path>
                    <path d="M8.74023 9.5H7.24023C6.96409 9.5 6.74023 9.72386 6.74023 10V11.5C6.74023 11.7761 6.96409 12 7.24023 12H8.74023C9.01638 12 9.24023 11.7761 9.24023 11.5V10C9.24023 9.72386 9.01638 9.5 8.74023 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M12.75 9.5H11.25C10.9739 9.5 10.75 9.72386 10.75 10V11.5C10.75 11.7761 10.9739 12 11.25 12H12.75C13.0261 12 13.25 11.7761 13.25 11.5V10C13.25 9.72386 13.0261 9.5 12.75 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M16.7598 9.5H15.2598C14.9836 9.5 14.7598 9.72386 14.7598 10V11.5C14.7598 11.7761 14.9836 12 15.2598 12H16.7598C17.0359 12 17.2598 11.7761 17.2598 11.5V10C17.2598 9.72386 17.0359 9.5 16.7598 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M16.5 3.01953H15.5C15.2239 3.01953 15 3.24339 15 3.51953V5.51953C15 5.79567 15.2239 6.01953 15.5 6.01953H16.5C16.7761 6.01953 17 5.79567 17 5.51953V3.51953C17 3.24339 16.7761 3.01953 16.5 3.01953Z" fill="var(--color-brand)"></path>
                    <path d="M8.74023 14H7.24023C6.96409 14 6.74023 14.2239 6.74023 14.5V16C6.74023 16.2761 6.96409 16.5 7.24023 16.5H8.74023C9.01638 16.5 9.24023 16.2761 9.24023 16V14.5C9.24023 14.2239 9.01638 14 8.74023 14Z" fill="var(--color-surface)"></path>
                    <path d="M12.75 14H11.25C10.9739 14 10.75 14.2239 10.75 14.5V16C10.75 16.2761 10.9739 16.5 11.25 16.5H12.75C13.0261 16.5 13.25 16.2761 13.25 16V14.5C13.25 14.2239 13.0261 14 12.75 14Z" fill="var(--color-surface)"></path>
                    <path d="M16.7598 14H15.2598C14.9836 14 14.7598 14.2239 14.7598 14.5V16C14.7598 16.2761 14.9836 16.5 15.2598 16.5H16.7598C17.0359 16.5 17.2598 16.2761 17.2598 16V14.5C17.2598 14.2239 17.0359 14 16.7598 14Z" fill="var(--color-surface)"></path>
                  </svg>
                </div>
              </article>
              <article class="metric-card">
                <div class="metric-card__value">
                  <span class="num" data-target="80">0</span><span class="unit">%</span>
                </div>
                <p class="metric-card__label text-label" data-i18n="index-outcomes-metric-label-03" v-html="$rt('index-outcomes-metric-label-03')"></p>
                <div class="metric-card__visual" aria-hidden="true">
                  <svg class="metric-card__icon" viewBox="0 0 24 24" fill="none">
                    <path d="M18.8824 3H5.11765C3.9481 3 3 3.89543 3 5V19C3 20.1046 3.9481 21 5.11765 21H18.8824C20.0519 21 21 20.1046 21 19V5C21 3.89543 20.0519 3 18.8824 3Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M18.5 13H16.5V9.5H13V7.5H18.5V13Z" fill="var(--color-brand)"></path>
                    <path d="M16.3 8.21973L11 13.5097L8 10.5097L3 15.5V18.49L8 13.4997L11 16.4997L17.71 9.79973L16.3 8.21973Z" fill="var(--color-brand)"></path>
                  </svg>
                </div>
              </article>
            </div>
          </div>

          <div class="proof-card-stage">
            <div class="proof-card-deck" data-proof-deck="">
              <button type="button" class="proof-card-nav" aria-label="다른 사례 보기"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
              <div class="proof-card-deck-list">
                <article class="proof-card">
                  <img src="/images/clients/dark/logo-cj.svg" alt="CJ올리브네트웍스 로고">
                  <h3 data-i18n="index-outcomes-proof-title-01" v-html="$rt('index-outcomes-proof-title-01')"></h3>
                  <blockquote data-i18n="index-outcomes-proof-quote-01" v-html="$rt('index-outcomes-proof-quote-01')"></blockquote>
                  <cite data-i18n="index-outcomes-proof-cite-01" v-html="$rt('index-outcomes-proof-cite-01')"></cite>
                </article>
                <article class="proof-card">
                  <img src="/images/clients/dark/logo-translink.svg" alt="트랜스링크인베스트먼트 로고">
                  <h3 data-i18n="index-outcomes-proof-title-02" v-html="$rt('index-outcomes-proof-title-02')"></h3>
                  <blockquote data-i18n="index-outcomes-proof-quote-02" v-html="$rt('index-outcomes-proof-quote-02')"></blockquote>
                  <cite data-i18n="index-outcomes-proof-cite-02" v-html="$rt('index-outcomes-proof-cite-02')"></cite>
                </article>
              </div>
              <button type="button" class="proof-card-nav" aria-label="다음 사례 보기"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
            </div>
          </div>

        </div>
      </div>
    </section>

    <div class="parts-group">
      <section class="journey fade-up" id="part1-education">
        <div class="section-wrap row is-sticky">
          <div class="section-aside">
            <div class="section-title text-left">
              <nav class="part-nav" data-part-nav="" aria-label="교육·진단 섹션 이동">
                <span class="part-nav-indicator" data-part-nav-indicator="" aria-hidden="true"></span>
                <a class="part-nav-item" href="#part1-education" data-part-nav-item="part1-education"><span data-i18n="index-journey-nav-01" v-html="$rt('index-journey-nav-01')"></span></a>
                <a class="part-nav-item" href="#part2-diagnosis" data-part-nav-item="part2-diagnosis"><span data-i18n="index-journey-nav-02" v-html="$rt('index-journey-nav-02')"></span></a>
              </nav>
              <h2 data-i18n="index-journey-title" v-html="$rt('index-journey-title')"></h2>
              <p class="desc" data-i18n="index-journey-desc" v-html="$rt('index-journey-desc')"></p>
            </div>

            <div class="diagnosis-products">
              <p class="mini-title-sm" data-i18n="index-journey-products-label" v-html="$rt('index-journey-products-label')"></p>

              <ul class="choice-list">
                <li>
                  <button class="choice-list__item" type="button" data-journey-program="0">
                    <span class="icon-box" aria-hidden="true">
                      <img src="/images/icons/service/ic_skillPath.svg" alt="">
                    </span>
                    <span class="choice-list__body">
                      <span class="choice-list__title">SkillPath </span>
                      <span class="text-caption" data-i18n="index-journey-item-caption-01" v-html="$rt('index-journey-item-caption-01')"></span>
                    </span>
                    <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </button>
                </li>
                <li>
                  <button class="choice-list__item" type="button" data-journey-program="1">
                    <span class="icon-box" aria-hidden="true">
                      <img src="/images/icons/service/ic_edu.svg" alt="">
                    </span>
                    <span class="choice-list__body">
                      <span class="choice-list__title">SkillCamp </span>
                      <span class="text-caption" data-i18n="index-journey-item-caption-02" v-html="$rt('index-journey-item-caption-02')"></span>
                    </span>
                    <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </button>
                </li>
                <li>
                  <button class="choice-list__item" type="button" data-journey-program="2">
                    <span class="icon-box" aria-hidden="true">
                      <img src="/images/icons/service/ic_skillFit.svg" alt="">
                    </span>
                    <span class="choice-list__body">
                      <span class="choice-list__title">SkillFit</span>
                      <span class="text-caption" data-i18n="index-journey-item-caption-03" v-html="$rt('index-journey-item-caption-03')"></span>
                    </span>
                    <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </button>
                </li>
              </ul>
            </div>

            <a href="/skills" class="btn btn-primary"><span data-i18n="index-journey-cta" v-html="$rt('index-journey-cta')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </div>

          <div class="journey-stage" data-journey-stage="">
            <div class="journey-track" data-journey-track="">
              <div data-journey-track-step="0"></div>
              <div data-journey-track-step="1"></div>
              <div data-journey-track-step="2"></div>
            </div>

            <div class="content-panel journey-viewport surface-glass">
              <article class="content-panel__item journey-step is-active" data-journey-step="0">
                <div class="content-panel__visual preview-frame preview-frame--flush learning-preview" aria-hidden="true">
                  <img src="/images/products/skillpath/skillpath-hero.svg" alt="">
                </div>

                <div class="content-panel__intro">
                  <p class="mini-title-sm" data-i18n="index-journey-step-label-01" v-html="$rt('index-journey-step-label-01')"></p>
                  <h3 data-i18n="index-journey-step-title-01" v-html="$rt('index-journey-step-title-01')"></h3>
                  <p class="desc" data-i18n="index-journey-step-desc-01" v-html="$rt('index-journey-step-desc-01')"></p>
                </div>
              </article>

              <article class="content-panel__item journey-step" data-journey-step="1">
                <div class="content-panel__visual preview-frame preview-frame--flush learning-preview" aria-hidden="true">
                  <img src="/images/products/skillcamp-hero.svg" alt="">
                </div>

                <div class="content-panel__intro">
                  <p class="mini-title-sm" data-i18n="index-journey-step-label-02" v-html="$rt('index-journey-step-label-02')"></p>
                  <h3 data-i18n="index-journey-step-title-02" v-html="$rt('index-journey-step-title-02')"></h3>
                  <p class="desc" data-i18n="index-journey-step-desc-02" v-html="$rt('index-journey-step-desc-02')"></p>
                </div>
              </article>

              <article class="content-panel__item journey-step" data-journey-step="2">
                <div class="content-panel__visual preview-frame preview-frame--flush learning-preview" aria-hidden="true">
                  <img src="/images/mockups/skillfit-hero-v1.svg" alt="">
                </div>

                <div class="content-panel__intro">
                  <p class="mini-title-sm" data-i18n="index-journey-step-label-03" v-html="$rt('index-journey-step-label-03')"></p>
                  <h3 data-i18n="index-journey-step-title-03" v-html="$rt('index-journey-step-title-03')"></h3>
                  <p class="desc" data-i18n="index-journey-step-desc-03" v-html="$rt('index-journey-step-desc-03')"></p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section class="diagnosis fade-up" id="part2-diagnosis">
        <div class="section-wrap row is-sticky">
          <div class="section-aside">
            <div class="section-title text-left">
              <nav class="part-nav" data-part-nav="" aria-label="교육·진단 섹션 이동">
                <span class="part-nav-indicator" data-part-nav-indicator="" aria-hidden="true"></span>
                <a class="part-nav-item" href="#part1-education" data-part-nav-item="part1-education"><span data-i18n="index-journey-nav-01" v-html="$rt('index-journey-nav-01')"></span></a>
                <a class="part-nav-item" href="#part2-diagnosis" data-part-nav-item="part2-diagnosis"><span data-i18n="index-journey-nav-02" v-html="$rt('index-journey-nav-02')"></span></a>
              </nav>
              <h2 data-i18n="index-diagnosis-title" v-html="$rt('index-diagnosis-title')"></h2>
              <p class="desc" data-i18n="index-diagnosis-desc" v-html="$rt('index-diagnosis-desc')"></p>
            </div>

            <div class="diagnosis-products">
              <p class="mini-title-sm" data-i18n="index-diagnosis-products-label" v-html="$rt('index-diagnosis-products-label')"></p>

              <ul class="choice-list">
                <li>
                  <button class="choice-list__item" type="button" data-diagnosis-program="0">
                    <span class="icon-box" aria-hidden="true">
                      <img src="/images/icons/service/ic_aiFluent.svg" alt="">
                    </span>
                    <span class="choice-list__body">
                      <span class="choice-list__title">AI Fluent</span>
                      <span class="text-caption" data-i18n="index-diagnosis-item-caption-01" v-html="$rt('index-diagnosis-item-caption-01')"></span>
                    </span>
                    <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </button>
                </li>
                <li>
                  <button class="choice-list__item" type="button" data-diagnosis-program="1">
                    <span class="icon-box" aria-hidden="true">
                      <img src="/images/icons/service/ic_skillCertify.svg" alt="">
                    </span>
                    <span class="choice-list__body">
                      <span class="choice-list__title">SkillCertify</span>
                      <span class="text-caption" data-i18n="index-diagnosis-item-caption-02" v-html="$rt('index-diagnosis-item-caption-02')"></span>
                    </span>
                    <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </button>
                </li>
              </ul>
            </div>

            <a href="/skills" class="btn btn-primary"><span data-i18n="index-diagnosis-cta" v-html="$rt('index-diagnosis-cta')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </div>

          <div class="journey-stage diagnosis-preview" data-diagnosis-stage="">
            <div class="journey-track" data-diagnosis-track="">
              <div data-diagnosis-track-step="0"></div>
              <div data-diagnosis-track-step="1"></div>
            </div>

            <div class="content-panel journey-viewport diagnosis-preview-panel surface-glass">
              <figure class="content-panel__item journey-step is-active" data-diagnosis-step="0">
                <img class="content-panel__visual diagnosis-preview-image" src="/images/products/aifluent/aifluent-sample.svg" alt="AI Fluent 전 직군 AI 활용 역량 진단 리포트 화면">
                <figcaption class="content-panel__intro diagnosis-preview-caption">
                  <p class="mini-title-sm" data-i18n="index-diagnosis-preview-label-01" v-html="$rt('index-diagnosis-preview-label-01')"></p>
                  <h3 data-i18n="index-diagnosis-preview-title-01" v-html="$rt('index-diagnosis-preview-title-01')"></h3>
                  <p class="desc" data-i18n="index-diagnosis-preview-desc-01" v-html="$rt('index-diagnosis-preview-desc-01')"></p>
                </figcaption>
              </figure>

              <figure class="content-panel__item journey-step" data-diagnosis-step="1">
                <img class="content-panel__visual diagnosis-preview-image" src="/images/products/skillcertify/skillcertify-sample.svg" alt="SkillCertify 개발자 IT 실무 역량 평가 리포트 화면">
                <figcaption class="content-panel__intro diagnosis-preview-caption">
                  <p class="mini-title-sm" data-i18n="index-diagnosis-preview-label-02" v-html="$rt('index-diagnosis-preview-label-02')"></p>
                  <h3 data-i18n="index-diagnosis-preview-title-02" v-html="$rt('index-diagnosis-preview-title-02')"></h3>
                  <p class="desc" data-i18n="index-diagnosis-preview-desc-02" v-html="$rt('index-diagnosis-preview-desc-02')"></p>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="difference fade-up" id="part3-difference">
      <div class="section-wrap col difference-layout">

        <div class="section-header">
          <div class="section-title text-left">
            <p class="mini-title" data-i18n="index-difference-eyebrow" v-html="$rt('index-difference-eyebrow')"></p>
            <h2 data-i18n="index-difference-title" v-html="$rt('index-difference-title')"></h2>
            <p class="desc" data-i18n="index-difference-desc" v-html="$rt('index-difference-desc')"></p>
          </div>
          <div class="section-cta">
            <a href="/why-codepresso" class="btn btn-primary"><span data-i18n="index-difference-cta" v-html="$rt('index-difference-cta')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </div>
        </div>

        <ul class="difference-blocks">

            <li>
              <div class="preview-frame preview-frame--flush" aria-hidden="true">
                <div class="preview-frame__bar">
                  <span class="preview-frame__dots"><i></i><i></i><i></i></span>
                </div>

                <div class="difference-screen">
                <div class="difference-screen-body is-cycle">

                  <div class="difference-card is-step is-first">
                    <div class="difference-step-head">
                      <span class="difference-step-no">1</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-01" v-html="$rt('index-difference-mock-01')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-02" v-html="$rt('index-difference-mock-02')"></span>
                    </div>

                    <ul class="difference-bars">
                      <li>
                        <span class="difference-gauge-bar">
                          <span style="--bar-h: 44%"></span>
                        </span>
                        <span class="difference-bar-value is-weak">44</span>
                        <span class="difference-bar-name" data-i18n="index-difference-mock-03" v-html="$rt('index-difference-mock-03')"></span>
                      </li>
                      <li>
                        <span class="difference-gauge-bar">
                          <span style="--bar-h: 32%"></span>
                        </span>
                        <span class="difference-bar-value is-weak">32</span>
                        <span class="difference-bar-name" data-i18n="index-difference-mock-04" v-html="$rt('index-difference-mock-04')"></span>
                      </li>
                      <li>
                        <span class="difference-gauge-bar">
                          <span style="--bar-h: 48%"></span>
                        </span>
                        <span class="difference-bar-value is-weak">48</span>
                        <span class="difference-bar-name" data-i18n="index-difference-mock-05" v-html="$rt('index-difference-mock-05')"></span>
                      </li>
                    </ul>

                    <span class="difference-card-foot" data-i18n="index-difference-mock-06" v-html="$rt('index-difference-mock-06')"></span>

                    <span class="difference-flow-arrow">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </div>

                  <div class="difference-card is-step is-mid">
                    <div class="difference-step-head">
                      <span class="difference-step-no">2</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-07" v-html="$rt('index-difference-mock-07')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-08" v-html="$rt('index-difference-mock-08')"></span>
                    </div>

                    <ul class="difference-stack">
                      <li class="difference-course">
                        <span class="difference-course-mark">1</span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-09" v-html="$rt('index-difference-mock-09')"></span>
                        </span>
                        <span class="difference-chip is-brand" data-i18n="index-difference-mock-10" v-html="$rt('index-difference-mock-10')"></span>
                      </li>
                      <li class="difference-course">
                        <span class="difference-course-mark">2</span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-11" v-html="$rt('index-difference-mock-11')"></span>
                        </span>
                        <span class="difference-chip is-brand" data-i18n="index-difference-mock-12" v-html="$rt('index-difference-mock-12')"></span>
                      </li>
                      <li class="difference-course is-quiet">
                        <span class="difference-course-mark">3</span>
                        <span class="difference-asset-body">
                          <span class="skeleton-line" style="width: 96px"></span>
                        </span>
                      </li>
                    </ul>

                    <div class="difference-progress">
                      <span class="difference-track"><span style="width: 82%"></span></span>
                      <span class="difference-bar-value">82%</span>
                    </div>

                    <span class="difference-card-foot" data-i18n="index-difference-mock-13" v-html="$rt('index-difference-mock-13')"></span>

                    <span class="difference-flow-arrow">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </div>

                  <div class="difference-card is-step is-last">
                    <div class="difference-step-head">
                      <span class="difference-step-no">3</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-14" v-html="$rt('index-difference-mock-14')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-15" v-html="$rt('index-difference-mock-15')"></span>
                    </div>

                    <ul class="difference-bars">
                      <li>
                        <span class="difference-gauge-bar">
                          <span style="--bar-h: 44%"></span>
                          <span class="is-after" style="--bar-h: 86%"></span>
                        </span>
                        <span class="difference-bar-value">+42</span>
                        <span class="difference-bar-name" data-i18n="index-difference-mock-16" v-html="$rt('index-difference-mock-16')"></span>
                      </li>
                      <li>
                        <span class="difference-gauge-bar">
                          <span style="--bar-h: 32%"></span>
                          <span class="is-after" style="--bar-h: 71%"></span>
                        </span>
                        <span class="difference-bar-value">+39</span>
                        <span class="difference-bar-name" data-i18n="index-difference-mock-17" v-html="$rt('index-difference-mock-17')"></span>
                      </li>
                      <li>
                        <span class="difference-gauge-bar">
                          <span style="--bar-h: 48%"></span>
                          <span class="is-after" style="--bar-h: 74%"></span>
                        </span>
                        <span class="difference-bar-value">+26</span>
                        <span class="difference-bar-name" data-i18n="index-difference-mock-18" v-html="$rt('index-difference-mock-18')"></span>
                      </li>
                    </ul>

                    <span class="difference-legend-key">
                      <span class="difference-key" data-i18n="index-difference-mock-19" v-html="$rt('index-difference-mock-19')"></span>
                      <span class="difference-key is-brand" data-i18n="index-difference-mock-20" v-html="$rt('index-difference-mock-20')"></span>
                    </span>

                    <span class="difference-verdict">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M12 19V5M12 5l-6 6M12 5l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span data-i18n="index-difference-mock-21" v-html="$rt('index-difference-mock-21')"></span>
                    </span>
                  </div>

                </div>
                </div>
                <div class="difference-screen-indicator" aria-hidden="true">
                  <i></i><i></i><i></i>
                </div>
              </div>

              <div class="difference-block-head">
                <span class="difference-block-no">01</span>
                <h3 data-i18n="index-difference-block-title-01" v-html="$rt('index-difference-block-title-01')"></h3>
                <p class="desc" data-i18n="index-difference-block-desc-01" v-html="$rt('index-difference-block-desc-01')"></p>
              </div>
            </li>

            <li>
              <div class="preview-frame preview-frame--flush" aria-hidden="true">
                <div class="preview-frame__bar">
                  <span class="preview-frame__dots"><i></i><i></i><i></i></span>
                </div>

                <div class="difference-screen">
                <div class="difference-screen-body is-library">

                  <div class="difference-card is-step is-first">
                    <div class="difference-step-head">
                      <span class="difference-step-no">1</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-22" v-html="$rt('index-difference-mock-22')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-23" v-html="$rt('index-difference-mock-23')"></span>
                    </div>

                    <div class="difference-chat">
                      <div class="difference-chat-head">
                        <span class="journey-mock-avatar" data-i18n="index-difference-mock-24" v-html="$rt('index-difference-mock-24')"></span>
                        <span class="difference-asset-name" data-i18n="index-difference-mock-25" v-html="$rt('index-difference-mock-25')"></span>
                      </div>

                      <div class="difference-bubble is-them">
                        <span class="skeleton-line" style="width: 84px"></span>
                      </div>

                      <div class="difference-bubble is-me">
                        <span class="difference-bubble-text" data-i18n="index-difference-mock-26" v-html="$rt('index-difference-mock-26')"></span>

                        <span class="difference-attach">
                          <span class="difference-asset-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.5 3.5H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9l-5.5-5.5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                              <path d="M13.5 3.5V9H19" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                            </svg>
                          </span>
                          <span class="difference-attach-body">
                            <span class="difference-asset-name" data-i18n="index-difference-mock-27" v-html="$rt('index-difference-mock-27')"></span>
                            <span class="difference-attach-meta" data-i18n="index-difference-mock-28" v-html="$rt('index-difference-mock-28')"></span>
                          </span>
                        </span>
                      </div>

                      <span class="difference-chat-foot" data-i18n="index-difference-mock-29" v-html="$rt('index-difference-mock-29')"></span>
                    </div>

                    <span class="difference-flow-arrow">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </div>

                  <div class="difference-card is-step is-mid">
                    <div class="difference-step-head">
                      <span class="difference-step-no">2</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-30" v-html="$rt('index-difference-mock-30')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-31" v-html="$rt('index-difference-mock-31')"></span>
                    </div>

                    <ul class="difference-stack">
                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 15a3 3 0 0 1-3 3H8l-4 3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v9Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-32" v-html="$rt('index-difference-mock-32')"></span>
                        </span>
                        <span class="difference-chip is-brand" data-i18n="index-difference-mock-33" v-html="$rt('index-difference-mock-33')"></span>
                      </li>

                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.7"></circle>
                            <path d="M12 3v2.5m0 13V21M3 12h2.5m13 0H21M5.6 5.6l1.8 1.8m9.2 9.2 1.8 1.8M18.4 5.6l-1.8 1.8m-9.2 9.2-1.8 1.8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-34" v-html="$rt('index-difference-mock-34')"></span>
                        </span>
                        <span class="difference-chip" data-i18n="index-difference-mock-35" v-html="$rt('index-difference-mock-35')"></span>
                      </li>

                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" stroke="currentColor" stroke-width="1.7"></rect>
                            <path d="M3.5 9.5h17M9.5 9.5v10" stroke="currentColor" stroke-width="1.7"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-36" v-html="$rt('index-difference-mock-36')"></span>
                        </span>
                        <span class="difference-chip" data-i18n="index-difference-mock-37" v-html="$rt('index-difference-mock-37')"></span>
                      </li>

                      <li class="difference-asset is-quiet">
                        <span class="difference-asset-icon"></span>
                        <span class="difference-asset-body">
                          <span class="skeleton-line" style="width: 108px"></span>
                        </span>
                      </li>
                    </ul>

                    <span class="difference-card-foot" data-i18n="index-difference-mock-38" v-html="$rt('index-difference-mock-38')"></span>

                    <span class="difference-flow-arrow">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </div>

                  <div class="difference-card is-step is-last">
                    <div class="difference-step-head">
                      <span class="difference-step-no">3</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-39" v-html="$rt('index-difference-mock-39')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-40" v-html="$rt('index-difference-mock-40')"></span>
                    </div>

                    <div class="difference-spread-map">
                      <span class="difference-spread-wave"></span>
                      <span class="difference-spread-wave" style="animation-delay: 1.3s"></span>

                      <span class="difference-spread-core" data-i18n="index-difference-mock-41" v-html="$rt('index-difference-mock-41')"></span>

                      <span class="difference-spread-node" style="--node-x: 76%; --node-y: 14%" data-i18n="index-difference-mock-42" v-html="$rt('index-difference-mock-42')"></span>
                      <span class="difference-spread-node" style="--node-x: 78%; --node-y: 86%" data-i18n="index-difference-mock-43" v-html="$rt('index-difference-mock-43')"></span>
                      <span class="difference-spread-node" style="--node-x: 22%; --node-y: 14%" data-i18n="index-difference-mock-44" v-html="$rt('index-difference-mock-44')"></span>
                      <span class="difference-spread-node" style="--node-x: 20%; --node-y: 86%" data-i18n="index-difference-mock-45" v-html="$rt('index-difference-mock-45')"></span>
                    </div>

                    <span class="difference-card-foot" data-i18n="index-difference-mock-46" v-html="$rt('index-difference-mock-46')"></span>
                  </div>

                </div>
                </div>
                <div class="difference-screen-indicator" aria-hidden="true">
                  <i></i><i></i><i></i>
                </div>
              </div>

              <div class="difference-block-head">
                <span class="difference-block-no">02</span>
                <h3 data-i18n="index-difference-block-title-02" v-html="$rt('index-difference-block-title-02')"></h3>
                <p class="desc" data-i18n="index-difference-block-desc-02" v-html="$rt('index-difference-block-desc-02')"></p>
              </div>
            </li>

            <li>
              <div class="preview-frame preview-frame--flush" aria-hidden="true">
                <div class="preview-frame__bar">
                  <span class="preview-frame__dots"><i></i><i></i><i></i></span>
                </div>

                <div class="difference-screen is-dark">
                <div class="difference-screen-body is-field">

                  <div class="difference-card is-step is-first">
                    <div class="difference-step-head">
                      <span class="difference-step-no">1</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-47" v-html="$rt('index-difference-mock-47')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-48" v-html="$rt('index-difference-mock-48')"></span>
                    </div>

                    <ul class="difference-stack">
                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 20V10l5 3V10l5 3V6l6 3v11H4Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-49" v-html="$rt('index-difference-mock-49')"></span>
                        </span>
                      </li>
                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="3" y="6" width="18" height="12" rx="2.5" stroke="currentColor" stroke-width="1.7"></rect>
                            <path d="M3 10.5h18" stroke="currentColor" stroke-width="1.7"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-50" v-html="$rt('index-difference-mock-50')"></span>
                        </span>
                      </li>
                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 4h2.2l2.3 10.5h9.6L19 7H6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                            <circle cx="9" cy="19" r="1.4" stroke="currentColor" stroke-width="1.7"></circle>
                            <circle cx="17" cy="19" r="1.4" stroke="currentColor" stroke-width="1.7"></circle>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-51" v-html="$rt('index-difference-mock-51')"></span>
                        </span>
                      </li>
                    </ul>

                    <span class="difference-card-foot" data-i18n="index-difference-mock-52" v-html="$rt('index-difference-mock-52')"></span>

                    <span class="difference-flow-arrow">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </div>

                  <div class="difference-card is-step is-mid">
                    <div class="difference-step-head">
                      <span class="difference-step-no">2</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-53" v-html="$rt('index-difference-mock-53')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-54" v-html="$rt('index-difference-mock-54')"></span>
                    </div>

                    <ul class="difference-stack">
                      <li class="difference-trial is-pass">
                        <span class="difference-trial-mark">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-55" v-html="$rt('index-difference-mock-55')"></span>
                        </span>
                        <span class="difference-trial-count">38</span>
                      </li>
                      <li class="difference-trial is-fail">
                        <span class="difference-trial-mark">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-56" v-html="$rt('index-difference-mock-56')"></span>
                        </span>
                        <span class="difference-trial-count">14</span>
                      </li>
                    </ul>

                    <p class="difference-trial-note" data-i18n="index-difference-mock-57" v-html="$rt('index-difference-mock-57')"></p>

                    <span class="difference-flow-arrow">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </div>

                  <div class="difference-card is-step is-last">
                    <div class="difference-step-head">
                      <span class="difference-step-no">3</span>
                      <span class="difference-card-label" data-i18n="index-difference-mock-58" v-html="$rt('index-difference-mock-58')"></span>
                      <span class="difference-step-desc" data-i18n="index-difference-mock-59" v-html="$rt('index-difference-mock-59')"></span>
                    </div>

                    <ul class="difference-stack">
                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H10a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H5.5A1.5 1.5 0 0 1 4 15.5v-10Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                            <path d="M20 5.5A1.5 1.5 0 0 0 18.5 4H14a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h4.5a1.5 1.5 0 0 0 1.5-1.5v-10Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-60" v-html="$rt('index-difference-mock-60')"></span>
                        </span>
                        <span class="difference-chip is-brand" data-i18n="index-difference-mock-61" v-html="$rt('index-difference-mock-61')"></span>
                      </li>
                      <li class="difference-asset">
                        <span class="difference-asset-icon">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H10a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H5.5A1.5 1.5 0 0 1 4 15.5v-10Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                            <path d="M20 5.5A1.5 1.5 0 0 0 18.5 4H14a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h4.5a1.5 1.5 0 0 0 1.5-1.5v-10Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                          </svg>
                        </span>
                        <span class="difference-asset-body">
                          <span class="difference-asset-name" data-i18n="index-difference-mock-62" v-html="$rt('index-difference-mock-62')"></span>
                        </span>
                        <span class="difference-chip is-brand" data-i18n="index-difference-mock-63" v-html="$rt('index-difference-mock-63')"></span>
                      </li>
                    </ul>

                    <div class="difference-loop">
                      <span class="difference-loop-mark">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 11a8 8 0 1 0-2.3 5.7" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
                          <path d="M20 4.5V11h-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </span>
                      <p class="difference-loop-text" data-i18n="index-difference-mock-64" v-html="$rt('index-difference-mock-64')"></p>
                    </div>
                  </div>

                </div>
                </div>
                <div class="difference-screen-indicator" aria-hidden="true">
                  <i></i><i></i><i></i>
                </div>
              </div>

              <div class="difference-block-head">
                <span class="difference-block-no">03</span>
                <h3 data-i18n="index-difference-block-title-03" v-html="$rt('index-difference-block-title-03')"></h3>
                <p class="desc" data-i18n="index-difference-block-desc-03" v-html="$rt('index-difference-block-desc-03')"></p>
              </div>
            </li>
        </ul>

        <div class="difference-mobile">
          <div class="difference-mobile-group">
            <p class="difference-mobile-heading" data-i18n="index-difference-m-heading-01" v-html="$rt('index-difference-m-heading-01')"></p>
            <ul class="difference-mobile-row">
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M6 19V11M12 19V5M18 19v-6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-01" v-html="$rt('index-difference-m-item-title-01')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-01" v-html="$rt('index-difference-m-item-desc-01')"></span>
              </li>
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H10a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H5.5A1.5 1.5 0 0 1 4 15.5v-10Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                    <path d="M20 5.5A1.5 1.5 0 0 0 18.5 4H14a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h4.5a1.5 1.5 0 0 0 1.5-1.5v-10Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-02" v-html="$rt('index-difference-m-item-title-02')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-02" v-html="$rt('index-difference-m-item-desc-02')"></span>
              </li>
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M20 11a8 8 0 1 0-2.3 5.7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
                    <path d="M20 4.5V11h-6.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-03" v-html="$rt('index-difference-m-item-title-03')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-03" v-html="$rt('index-difference-m-item-desc-03')"></span>
              </li>
            </ul>
            <p class="difference-mobile-note" data-i18n="index-difference-m-note-01" v-html="$rt('index-difference-m-note-01')"></p>
          </div>

          <div class="difference-mobile-group">
            <p class="difference-mobile-heading" data-i18n="index-difference-m-heading-02" v-html="$rt('index-difference-m-heading-02')"></p>
            <ul class="difference-mobile-row">
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M20 15a3 3 0 0 1-3 3H8l-4 3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v9Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-04" v-html="$rt('index-difference-m-item-title-04')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-04" v-html="$rt('index-difference-m-item-desc-04')"></span>
              </li>
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" stroke="currentColor" stroke-width="1.7"></rect>
                    <path d="M3.5 9.5h17M9.5 9.5v10" stroke="currentColor" stroke-width="1.7"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-05" v-html="$rt('index-difference-m-item-title-05')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-05" v-html="$rt('index-difference-m-item-desc-05')"></span>
              </li>
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <circle cx="12" cy="12" r="2.5" stroke="currentColor" stroke-width="1.7"></circle>
                    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-06" v-html="$rt('index-difference-m-item-title-06')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-06" v-html="$rt('index-difference-m-item-desc-06')"></span>
              </li>
            </ul>
            <p class="difference-mobile-note" data-i18n="index-difference-m-note-02" v-html="$rt('index-difference-m-note-02')"></p>
          </div>

          <div class="difference-mobile-group">
            <p class="difference-mobile-heading" data-i18n="index-difference-m-heading-03" v-html="$rt('index-difference-m-heading-03')"></p>
            <ul class="difference-mobile-row">
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                    <circle cx="12" cy="10" r="2.5" stroke="currentColor" stroke-width="1.7"></circle>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-07" v-html="$rt('index-difference-m-item-title-07')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-07" v-html="$rt('index-difference-m-item-desc-07')"></span>
              </li>
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 12.5 9.5 18 20 6.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-08" v-html="$rt('index-difference-m-item-title-08')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-08" v-html="$rt('index-difference-m-item-desc-08')"></span>
              </li>
              <li>
                <span class="difference-mobile-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-13Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>
                    <path d="M8 9.5h8M8 14h5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
                  </svg>
                </span>
                <span class="difference-mobile-title" data-i18n="index-difference-m-item-title-09" v-html="$rt('index-difference-m-item-title-09')"></span>
                <span class="difference-mobile-desc" data-i18n="index-difference-m-item-desc-09" v-html="$rt('index-difference-m-item-desc-09')"></span>
              </li>
            </ul>
            <p class="difference-mobile-note" data-i18n="index-difference-m-note-03" v-html="$rt('index-difference-m-note-03')"></p>
          </div>

          <p class="difference-mobile-field" data-i18n="index-difference-m-field" v-html="$rt('index-difference-m-field')"></p>
        </div>

      </div>
    </section>

    <div class="dot-line"></div>

    <section class="insight fade-up" id="insight">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <h2 data-i18n="index-insight-title" v-html="$rt('index-insight-title')"></h2>
          <p class="desc" data-i18n="index-insight-desc" v-html="$rt('index-insight-desc')"></p>
        </div>

        <div class="section-content">
          <InsightList />

          <div class="insight-more">
            <a href="https://codepresso.io/home/news" class="btn btn-primary" target="_blank" rel="noopener"><span data-i18n="index-insight-cta" v-html="$rt('index-insight-cta')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-final fade-up">
      <div class="section-wrap col cta-final-inner">
        <h2 class="cta-final-title" data-i18n="index-cta-final-title" v-html="$rt('index-cta-final-title')"></h2>
        <p class="cta-final-desc" data-i18n="index-cta-final-desc" v-html="$rt('index-cta-final-desc')"></p>
        <div class="cta-final-actions">
          <a href="https://codepresso.io/home/contact" class="btn btn-primary ">
            <span data-i18n="index-cta-final-btn-01" v-html="$rt('index-cta-final-btn-01')"></span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
          <a href="/skills" class="btn btn-outline-inverse ">
            <span data-i18n="index-cta-final-btn-02" v-html="$rt('index-cta-final-btn-02')"></span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </div>
        <a href="https://ai-literacy.codepresso.io/" class="link-arrow link-arrow-inverse">
          <span class="link-underline" data-i18n="index-cta-final-link" v-html="$rt('index-cta-final-link')"></span>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </a>
      </div>
    </section>
  </main>

  <ClientInteractions :scripts='["js/fade-up.js","js/scroll-progress.js","js/header-scroll.js","js/nav-menu.js","js/proof-card-slider.js","js/stat-reveal.js","js/part-nav.js","js/journey-stage.js"]' />
</template>

<script setup lang="ts">
import ClientInteractions from '../components/ClientInteractions.vue'
import ClientLogoMarquee from '../components/ClientLogoMarquee.vue'
import InsightList from '../components/InsightList.vue'
import { useRenewalText } from '../composables/useRenewalText'
import ko from '../data/i18n-dist/Index/ko.json'
import en from '../data/i18n-dist/Index/en.json'
import ja from '../data/i18n-dist/Index/ja.json'
import vi from '../data/i18n-dist/Index/vi.json'
import es from '../data/i18n-dist/Index/es.json'

// 문자열은 data/i18n-dist 에서 온다 — 마크업은 키만 들고 있다.
const $rt = useRenewalText({ ko, en, ja, vi, es })
</script>
